/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-one-expression-per-line, react/jsx-no-duplicate-props, react/jsx-wrap-multilines */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import LazyPicture from 'gatsby-core-theme/src/hooks/lazy-picture';
import { translate, imagePrettyUrl, prettyTracker } from 'gatsby-core-theme/src/helpers/getters';
import SellingPoints from 'gatsby-core-theme/src/components/atoms/selling-points';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { Context } from '~context/TranslationsProvider';

import styles from './provider-banner.module.scss';

const ProviderBanner = ({ pageContext, isStorybook = false }) => {
  const provider = pageContext?.page?.relation?.provider;
  const { translations } = useContext(Context) || {};
  const getSellingPoints = (p) => {
    const arr = [];
    if (p?.selling_point_1) arr.push(p.selling_point_1);
    if (p?.selling_point_2) arr.push(p.selling_point_2);
    if (p?.selling_point_3) arr.push(p.selling_point_3);
    return arr;
  };
  return (
    <div>
      <div className={styles.bg}>
        <LazyPicture
          fallback={
            isStorybook
              ? './ground-image-soccer.jpg'
              : '../../../../../images/ground-image-soccer.jpg'
          }
          webp={
            isStorybook
              ? './ground-image-soccer.webp'
              : '../../../../../images/ground-image-soccer.webp'
          }
          alt="soccer"
          width={1440}
          height={860}
        />
      </div>
      <div className={styles.container}>
        <div className={styles.logo}>
          {/* imagePrettyUrl is not working fine!! ToDo: fix the url */}
          <Button
            to={prettyTracker(provider, 'main', true)}
            isInternalLink={false}
            targetBlank={false}
            noStyle
            btnText={
              <LazyImage
                src={imagePrettyUrl(provider?.square_logo)}
                alt={provider?.name}
                width={350}
                height={180}
              />
            }
            gtmClass="provider-banner-gtm logo-cta btn-cta"
          />
        </div>
        <div className={styles.text}>
          <h2>{provider?.name}</h2>
          <SellingPoints icon={<FaCheck />} sellingPoints={getSellingPoints(provider)} />
          <Button
            to={prettyTracker(provider, 'main', true)}
            className="primary"
            targetBlank={false}
            isInternalLink={false}
            btnText={
              <>
                <FaChevronCircleRight />
                {translate(translations, 'go_to', 'Go to')} {provider?.name}
              </>
            }
            gtmClass="provider-banner-gtm btn-cta"
          />
        </div>
      </div>
    </div>
  );
};

ProviderBanner.propTypes = {
  isStorybook: PropTypes.bool,
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      type: PropTypes.string,
      relation: PropTypes.shape({
        provider: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
};

export default ProviderBanner;
